module.exports = __webpack_public_path__ + "static/media/generaladvice.fc01e6e9.png";